"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typography = void 0;
exports.typography = {
    fontFamily: {
        base: "Sailec, Helvetica, Arial, sans-serif",
        code: "Roboto Mono, Bitstream Vera Sans Mono, Consolas, monospace",
    },
    fontWeight: {
        regular: 400,
        bold: 700,
    },
    fontSize: {
        body: {
            xs: "12px",
            sm: "13px",
            md: "14px",
        },
        heading: {
            $1: "34px",
            $2: "24px",
            $3: "18px",
            $4: "16px",
            $5: "14px",
            $6: "12px",
        },
    },
};
//# sourceMappingURL=index.js.map